import axios from 'axios';
import { requestPost } from '../request';
import apiPath from '../modules/apiPath';

const api = {
  GetAllBillList(payload, paging) {
    return axios({
      url: `${process.env.VUE_APP_QRAVED_APP_URL}/${
        apiPath.ORDERING_ORDER_BO_BILLING_LIST.path
      }`,
      params: {
        uid: payload.uid,
        outlet_code: payload.outletCode,
        order_type: payload.order_type,
        billing_status: payload.billing_status,
        size: paging.size,
        page: paging.page,
        filter: payload.filter
      }
    });
  },

  UpdateBillStatus(payload) {
    return requestPost('updatebillstatus', payload);
  },

  UpdateBillDiscount(payload) {
    return requestPost('updatebilldiscount', payload);
  }
};

export default api;
